import React from 'react'
import { DashboardLayout } from '../layouts'
import { AdminsTopBar } from '../components'
import { AdminsContainer } from '../containers'

function Admins() {

    return (

        <DashboardLayout>
            <div>

                <AdminsTopBar />
                <AdminsContainer/>
            </div>
        </DashboardLayout>
    )
}

export default Admins